/**
 * 首页
 * 2017-12-6
 */
"use strict";
angular.module("messageModule", []).
controller("messageCtrl", ["$scope", "localStorageService", "httpService", "$filter", function($scope, localStorageService, httpService, $filter) {
    initStatus();
    initData();

    function initStatus() {
        $scope.page = {
            "CURRPAGE": 1,
            "PAGESIZE": 12,
            "ITEMCOUNT": 0
        };
        $scope.status = {
            selectE: ''
        };
        $scope.data = {
            listData: []
        };
    }

    function initData() {
        requestData();
    }
    /**
     * [requestData description] 初始数据
     * @return {[type]} [description]
     */
    $scope.requestData = function() {
        requestData();
    };

    function requestData() {

        var params = {
            currPage: $scope.page.CURRPAGE,
            pageSize: $scope.page.PAGESIZE
        };
        $scope.loadingPromise = httpService.http("/mcnww/web/message/page.do", params, "get").then(function(data) {
            $scope.data.listData = data.data;
            $scope.page = {
                CURRPAGE: data.data.startPage,
                PAGESIZE: data.data.pageSize,
                ITEMCOUNT: data.data.totalResults,
                PAGECOUNT: data.data.totalPages
            };
        });
    };
    /**
     * [dateFormat description] 时间格式化
     * @return {[type]} [description]
     */
    $scope.dateFormat = function(item) {
        item.newTime = $filter("date")(item.crtime, "yyyy-MM-dd HH:mm:ss").toString();
    };
    /**
     * [showContent description] 显示内容
     * @return {[type]} [description] item
     */
    $scope.showContent = function(item) {
        item.show = item.show === true ? false : true;
        $scope.status.selectE = item.id;
        if (!!item.contentData) {
            return;
        }
        var params = {
            messageId: item.id
        };
        $scope.loadingPromise = httpService.http("/mcnww/web/message/findById.do", params, "get").then(function(data) {
            for(var i=0;i<$scope.data.listData.length;i++){
                if($scope.data.listData[i].id == item.id){
                    $scope.data.listData[i].status = data.message.status;
                }
            }
            item.contentData = data.message.messageContent;
            localStorageService.set("readMessage", Math.random());
            $scope.$root.$broadcast("readMessage",true);
        });
    };
}]);